import { ReadonlyURLSearchParams } from "next/navigation";

export const removeQueryParameter = (
  searchParameters: ReadonlyURLSearchParams,
  key: string
) => {
  const currentParameters = new URLSearchParams(searchParameters);
  currentParameters.delete(key);
  return `?${currentParameters.toString()}`;
};

export const addQueryParameters = (
  searchParameters: ReadonlyURLSearchParams,
  newParameters: Record<string, string>
) => {
  const currentParameters = new URLSearchParams(searchParameters);
  for (const [key, value] of Object.entries(newParameters).filter(([key]) =>
    Boolean(key)
  )) {
    currentParameters.set(key, value);
  }
  return `?${currentParameters.toString()}`;
};

export const removeQueryParameters = (
  searchParameters: ReadonlyURLSearchParams,
  keys: Array<string>
) => {
  const currentParameters = new URLSearchParams(searchParameters);
  for (const key of keys) {
    currentParameters.delete(key);
  }

  return `?${currentParameters.toString()}`;
};
